/* eslint-disable no-unused-vars */
import { useState } from 'react';
import Ic from '../Icon';

export default function BroadcastMsg({ tenants = [], addMessage }) {
  const [body,      setBody]      = useState('');
  const [selectAll, setSelectAll] = useState(true);
  const [selected,  setSelected]  = useState(new Set());
  const [sending,   setSending]   = useState(false);
  const [sent,      setSent]      = useState(false);

  const toggleTenant = id => {
    if (selectAll) {
      setSelectAll(false);
      setSelected(new Set(tenants.map(t => t.id).filter(i => i !== id)));
    } else {
      setSelected(prev => {
        const next = new Set(prev);
        if (next.has(id)) next.delete(id); else next.add(id);
        return next;
      });
    }
  };

  const handleSelectAll = () => {
    if (selectAll) { setSelectAll(false); setSelected(new Set()); }
    else           { setSelectAll(true);  setSelected(new Set()); }
  };

  const recipients = selectAll ? tenants : tenants.filter(t => selected.has(t.id));

  const sendBroadcast = async () => {
    if (!body.trim() || recipients.length === 0 || !addMessage) return;
    setSending(true);
    for (const t of recipients) {
      await addMessage({
        tenant_id:   t.id,
        sender_role: 'landlord',
        body:        body.trim(),
        sent_at:     new Date().toISOString(),
        read:        false,
      });
    }
    setSent(true);
    setSending(false);
    setBody('');
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <div>
      <div className="card">
        <div className="card-hd"><h3>Compose Broadcast</h3></div>
        <div className="fg" style={{ marginBottom:0 }}>
          <div className="fi fi-f">
            <label>Message</label>
            <textarea
              style={{ background:'#21262d', border:'1px solid #2d333b', borderRadius:8, padding:'10px 12px', color:'#f5f0e8', fontSize:13, fontFamily:'Outfit,sans-serif', resize:'vertical', minHeight:120, outline:'none', width:'100%', boxSizing:'border-box' }}
              value={body}
              onChange={e => setBody(e.target.value)}
              placeholder="Type your message to all selected tenants..."
            />
          </div>
        </div>
        <div style={{ display:'flex', justifyContent:'flex-end', gap:10, marginTop:12 }}>
          {!addMessage && (
            <span style={{ fontSize:12, color:'#484f58', alignSelf:'center' }}>Demo mode — messages won't be saved</span>
          )}
          <button className="btn btn-g" onClick={sendBroadcast}
            disabled={!body.trim() || recipients.length === 0 || sending}
            style={{ padding:'8px 20px' }}>
            <Ic n="send" s={14}/>
            {sending ? `Sending to ${recipients.length}...` : sent ? 'Sent!' : `Send to ${recipients.length} tenant${recipients.length !== 1 ? 's' : ''}`}
          </button>
        </div>
      </div>

      <div className="card">
        <div className="card-hd">
          <h3>Recipients</h3>
          <button className="btn btn-gh" style={{ padding:'5px 12px', fontSize:12 }} onClick={handleSelectAll}>
            {selectAll ? 'Deselect All' : 'Select All'}
          </button>
        </div>
        {tenants.length === 0 ? (
          <div style={{ textAlign:'center', padding:'32px', color:'#484f58', fontSize:13 }}>No tenants yet.</div>
        ) : (
          <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
            {tenants.map(t => {
              const isSelected = selectAll || selected.has(t.id);
              const initials   = (t.full_name || t.name || '?').split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
              return (
                <div key={t.id}
                  onClick={() => toggleTenant(t.id)}
                  style={{ display:'flex', alignItems:'center', gap:12, padding:'11px 0', borderBottom:'1px solid #21262d', cursor:'pointer', opacity: isSelected ? 1 : 0.45 }}>
                  <div style={{ width:18, height:18, borderRadius:4, border:`2px solid ${isSelected ? '#4ade80' : '#484f58'}`, background: isSelected ? 'rgba(74,222,128,.15)' : 'transparent', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    {isSelected && <Ic n="check" s={10} c="#4ade80"/>}
                  </div>
                  <div className="av" style={{ width:32, height:32, fontSize:11 }}>{initials}</div>
                  <div>
                    <div style={{ fontSize:13, fontWeight:500, color:'#fff' }}>{t.full_name || t.name}</div>
                    <div style={{ fontSize:11, color:'#484f58' }}>Unit {t.unit || t.u || '—'}</div>
                  </div>
                  {isSelected && <span className="b bg" style={{ marginLeft:'auto', fontSize:10 }}>Selected</span>}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
